import { IFilters } from '../components/TableFilters/useFilters';
import { StatsType } from '../config/stats';

export const generateTableParams = (statName: StatsType) => {
  return {
    // date: APP_CONFIG.date,
    statName,
  };
};

export const transformFilters = (filters: IFilters, isPredictionFilters = false) => {
  const fallback = isPredictionFilters ? 'classic' : 'avg';
  return {
    sortType: filters?.sortType?.split?.('-')[0] || fallback,
    sortDirection: filters?.sortType?.split?.('-')[1] || 'desc',
    date: filters.date,
    search: filters.search,
  };
};
